// extracted by mini-css-extract-plugin
export var docLink = "doc-link_zQLPmvS2VENf0TK8RuXl";
export var dropZone = "drop-zone_SknE7Y2dTXGbKXYZb91P";
export var dropZoneActive = "drop-zone-active_NOj0Ievb1l_PYqMtFbOQ";
export var dropZoneHint = "drop-zone-hint_YVsPL3qViVrs2MeSpY8F";
export var dropZoneIcon = "drop-zone-icon_OroZQe6bTgt0_U6epSe_";
export var dropZoneText = "drop-zone-text_OQchDa0WFy3FfNnMwk72";
export var errorText = "error-text_NMaKhiNWpF3BEDziZuTX";
export var fieldGroup = "field-group_yLtJmUIvZHPXbw_kVudu";
export var fileIndicator = "file-indicator_GXXBcYApMsQwaBjUaoj6";
export var fileName = "file-name_T0Xtp1UL2nf_ivawREox";
export var finalizeErrorTitle = "finalize-error-title_RFSnmrlNyFXYYHTrsr3g";
export var infoIcon = "info-icon_w4veUHalh8hg_unZx_gC";
export var instructionsList = "instructions-list_h1GDV6l_ykMhCeUEs99k";
export var instructionsSection = "instructions-section_aMDlDF6HfPXhXEaz03lc";
export var loadingIndicator = "loading-indicator_Qr0HgfT9PotyB4AYFTgb";
export var successIndicator = "success-indicator_j37EABcKitQkrfRX1aYs";
export var tabContent = "tab-content_A_6eBhmzQXPeytdoHlIm";
export var titleRow = "title-row_UpZUR5KRUMCUXYv2DyGk";
export var uploadMetadataContainer = "upload-metadata-container_NZXOe1dXtSnQ1TdqlxI8";
export var warningText = "warning-text_PyexwrhJakUb_d7oNm2O";